import * as React from "react";
import {ReactElement} from "react";
import {useStoreValue} from "react-context-hook";
import {DateTime} from "luxon";
import {isMobileDevice} from "../../../layout/device";
import {getLocale} from "../../services/configuration.service";
import cookie from "react-cookies";
import {getUrlVar} from "orxapi.tools.url";
import {urlParametersConfig} from "../../../config/form";

const BookingData = (): ReactElement => {
    /**
     *  TODO
     *  - refactor to generate parameters in java
     *  - add birthdate for children pax
     *  - add product url and product detail url
     */
    const selectedDepartureCity = useStoreValue("selectedDepartureCity");
    const selectedDuration = useStoreValue("selectedDuration");
    const selectedDepartureDate = useStoreValue("selectedDepartureDate");
    const bookingEngineData = useStoreValue("bookingEngineData");
    const product = (bookingEngineData || {}).product;
    const userCode = (bookingEngineData || {}).userCode;
    const complementaryParameters = (bookingEngineData || {}).complementaryParameters;
    const isLocProduct = product && product.criteria.criteria && product.criteria.criteria.tvoyages
        && product.criteria.criteria.tvoyages[0] && product.criteria.criteria.tvoyages[0].code === "bien-etre";
    const enableRequest = product && product.criteria.criteria && product.criteria.criteria.enableRequest
        && product.criteria.criteria.enableRequest[0] && product.criteria.criteria.enableRequest[0].code === "OUI";
    const destinationCity = product && product.toCountries && product.toCountries[0]
        && product.toCountries[0].cities && product.toCountries[0].cities[0] && product.toCountries[0].cities[0].label;
    const productProvider = product && product.tourOperator;
    const toCode = product && product.toCode;
    const productPdfUrl = product && product.productPdfUrl;
    const productId = product && product.code;
    const locale = getLocale();
    const localeArray = locale && locale.split("_");
    const localeLanguage = localeArray[0];
    const localeCountry = localeArray[1];

    let travellerIndex = 0;
    const pax = useStoreValue("pax");
    const nbAdults = pax.nbAdults;
    const nbChildren = pax.nbChildren;
    const pathname = window.location.pathname;
    const productUrl = window.location.href;
    let isB2b = false;
    if (pathname && pathname.indexOf("/b2b") !== -1) {
        isB2b = true;
    }
    let channelCode = isMobileDevice() ? "B2C_MOBILE" : "B2C";
    if (isB2b) {
        channelCode = "B2B";
        if (productProvider && productProvider.code) {
            if (productProvider.code.startsWith("INT_")) {
                channelCode = "B2B_INT";
            } else if (isLocProduct) {
                channelCode = "B2B_LOCATION";
            }
            if (productProvider.code === "LASTMINUTE") {
                channelCode = "PREPACKAGE_B2B";
            }
        }
    } else {
        const useAdv = cookie.load("useAdv");
        if (productProvider && productProvider.code) {
            if (productProvider.code.startsWith("INT_")) {
                channelCode = isMobileDevice() ? "B2C_INT_MOBILE" : "B2C_INT";
            } else if (isLocProduct) {
                channelCode = isMobileDevice() ? "B2C_LOCATION_MOBILE" : "B2C_LOCATION";
            }
            if (productProvider.code === "LASTMINUTE") {
                channelCode = isMobileDevice() ? "PREPACKAGE_B2C_MOBILE" : "PREPACKAGE_B2C";
            }
            if (useAdv && useAdv !== "" && !isMobileDevice()) {
                channelCode += "_ADV";
            }
        }
    }
    const availability = (selectedDepartureDate && selectedDuration) && (selectedDepartureDate.code + "-" + selectedDuration.code);
    const durationStay = selectedDuration && selectedDuration.code;
    const monthYear = selectedDepartureDate && DateTime.fromFormat(selectedDepartureDate.code, "dd-MM-yyyy")
        .setLocale(getLocale().replace("_", "-"))
        .toFormat("MM-yy");
    let trackingId = getUrlVar()[urlParametersConfig.trackingId];
    if (trackingId && trackingId !== "") {
        setCookieValue("dpTrackingId", trackingId, 24 * 30);
    } else {
        trackingId = cookie.load("dpTrackingId");
    }

    let onlyLodging = false;
    if (product && product.departureCities) {
        const isWithoutTransport = Boolean(product.departureCities.filter((city: any) => city.code.toUpperCase() === "XXX").length);
        onlyLodging = !isLocProduct && isWithoutTransport;
    }

    return (
        <div>
            {localeLanguage && <input name="locale.language" type="hidden" value={localeLanguage}/>}
            {localeCountry && <input name="locale.country" type="hidden" value={localeCountry}/>}
            {selectedDepartureCity && <input name="depCityCode" type="hidden" value={selectedDepartureCity.code}/>}
            {availability && <input name="disponibility" type="hidden" value={availability}/>}
            {availability && <input name="durationStay" type="hidden" value={durationStay}/>}
            {availability && <input name="monthYear" type="hidden" value={monthYear}/>}
            {destinationCity && <input name="destCountry" type="hidden" value={destinationCity}/>}
            {productId && <input name="catalogCode" type="hidden" value={productId}/>}
            {toCode && <input name="toCode" type="hidden" value={toCode}/>}
            {productProvider && productProvider.code && <input name="provider" type="hidden" value={productProvider.code}/>}
            {enableRequest && <input name="reservationProfile.defaultResConfigCode" type="hidden" value={"REQUEST_DISPO_ENABLED"}/>}
            {productUrl && <input name="productUrl" type="hidden" value={productUrl}/>}
            {productPdfUrl && <input name="productPdfUrl" type="hidden" value={productPdfUrl}/>}
            {trackingId && <input name="marketingCode" type="hidden" value={trackingId.split("#")[0]}/>}
            {isB2b && <input name="reservationProfile.organization.code" type="hidden" value={userCode}/>}
            {complementaryParameters && <input name="complementaryParameters" type="hidden" value={complementaryParameters}/>}
            {Array(nbAdults).fill(1).map(() => {
                const currentIndex = travellerIndex;
                travellerIndex++;
                return (
                    <input name={`traveller[${currentIndex}].type`} type="hidden" value={"A"} key={`traveller[${currentIndex}].type`}/>
                );
            })}
            {Array(nbChildren).fill(1).map(() => {
                const currentIndex = travellerIndex;
                travellerIndex++;
                return (
                    <input name={`traveller[${currentIndex}].type`} key={`traveller[${currentIndex}].type`} type="hidden" value={"C"}/>
                );
            })}
            <input name="reservationProfileChannelCode" type="hidden" value={channelCode}/>
            {onlyLodging && <input name="transverseConfigCodes" type="hidden" value="HEBERGEMENT_SEUL"/>}
        </div>
    );
};

/**
 * setCookie
 */
function setCookieValue(name: string, value: string, durationHour: number) {
    const date = new Date();
    date.setTime(date.getTime() + (durationHour * 60 * 60 * 1000));
    cookie.save(name, value, {path: "/", expires: date});
}

export default BookingData;
